import {
  HashRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import HomePage from "./pages";
import LoginPage from "./pages/Login";
import { MainLayout } from "./layout/MainLayout";
import AddOrderForm from "./pages/add-order";
import RegisterPage from "./pages/register";
import OrderListPage from "./pages/order-list";
import Transaction from "./pages/transaction";
import TransactionDetailPage from "./pages/order-list/detail";
import ProductPage from "./pages/product";
import UserPage from "./pages/user";
import ClientSideProvider from "./context/ClientSideProvider";
import TenantPage from "./pages/tenant";
import ProductCreate from "./pages/product/create";
import UserCreate from "./pages/user/create";
import TenantCreate from "./pages/tenant/create";
import { useEffect } from "react";
import { getToken } from "./utils/API";
import AddOrderOmniPage from "./pages/add-order-omni";
import PageLogs from "./pages/order-list/logs";
import VerifyOTP from "./pages/add-order/verify-otp";
import "react-loading-skeleton/dist/skeleton.css";
import UserUpdate from "./pages/user/edit";
import HifiairForm from "./pages/hifiair";
import ProfileEdit from "./pages/profile";
import OrderListHifiairPage from "./pages/order-list-hifiair";
import ProductUpdate from "./pages/product/update";
import CategoryPage from "./pages/category";
import CategoryCreate from "./pages/category/create";
import CategoryUpdate from "./pages/category/update";

const AuthCheck = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = getToken();

    if (location.pathname === "/hifiair") {
      return;
    }
    if (!token && location.pathname !== "/login") {
      navigate("/login", { replace: true });
    }

    if (token && location.pathname === "/") {
      navigate("/order-list", { replace: true });
    }
  }, [navigate, location.pathname]);

  return null;
};

const App = () => {
  return (
    // Menempatkan ClientSideProvider di luar Router agar semua bagian aplikasi mendapatkan akses ke React Query, Recoil, dan Toastify
    <ClientSideProvider>
      <Router>
        <AuthCheck />
        <MainLayout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/add-order" element={<AddOrderForm />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/order-list" element={<OrderListPage />} />
            <Route path="/transaction" element={<Transaction />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/product/create" element={<ProductCreate />} />
            <Route path="/product/update/:id" element={<ProductUpdate />} />
            <Route path="/category" element={<CategoryPage />} />
            <Route path="/category/create" element={<CategoryCreate />} />
            <Route path="/category/update/:id" element={<CategoryUpdate />} />
            <Route path="/user/create" element={<UserCreate />} />
            <Route path="/tenant/create" element={<TenantCreate />} />
            <Route path="/user" element={<UserPage />} />
            <Route path="/tenant" element={<TenantPage />} />
            <Route path="/add-order/omni" element={<AddOrderOmniPage />} />
            <Route
              path="/order-list/detail/:id"
              element={<TransactionDetailPage />}
            />
            <Route path="/order-list/logs/:id" element={<PageLogs />} />
            <Route
              path="/add-order/verify-otp/:transactionId"
              element={<VerifyOTP />}
            />
            <Route path="/user/edit/:id" element={<UserUpdate />} />
            <Route path="/hifiair" element={<HifiairForm />} />
            <Route path="/profile" element={<ProfileEdit />} />
            <Route
              path="/order-list-hifiair"
              element={<OrderListHifiairPage />}
            />
          </Routes>
        </MainLayout>
      </Router>
    </ClientSideProvider>
  );
};

export default App;
